import prepaidSalesReducer from "./prepaidSalesReducer"
export default prepaidSalesReducer